export default "__VITE_ASSET__BNqKusEy__"